import React from 'react';
import { FooterContainer, FooterContent, FooterDetails, FooterHorarios, FooterLocal, FooterLogo, SocialIcons } from './FooterStyles';

import icon from 'src/assets/icon.png';
import { FaceIcon, WhatsIcon, InstaIcon, LabIcon } from 'src/styles/DesignSystem';

const Footer = ({ firtsComponent, bgColor, pt }) => {
    return (
        <FooterContainer bgColor={bgColor} pt={pt}>
            {firtsComponent}
            <FooterContent>
                <FooterLogo>
                    <img src={icon} alt="Hipermercado das Rações" />
                </FooterLogo>

                <FooterLocal>
                    Matteo Gianella, 176 - Santa Catarina, Caxias do Sul, RS <br />
                    <a href="tel:+55 54 3537-8297">(54) 3537-8297</a>
                    &nbsp; | &nbsp;
                    <a href="https://api.whatsapp.com/message/PBDXCR3XANWVC1?autoload=1&app_absent=0" target="_blank" rel="noopener noreferrer">
                        (54) 9 9255-3402 
                    </a>
                </FooterLocal>

                <FooterHorarios>
                    <p>
                        Seg. a Sex. <br />
                        08h as 20h
                    </p>

                    <p>
                        Sábado <br />
                        08h as 19h
                    </p>

                    <p>
                        Domingo <br />
                        14h as 19h
                    </p>
                </FooterHorarios>

                <SocialIcons>
                    <a href="https://www.facebook.com/"><FaceIcon /></a>
                    <a href="https://www.instagram.com/hiperdasracoes/"><InstaIcon /></a>
                    <a href="https://api.whatsapp.com/message/PBDXCR3XANWVC1?autoload=1&app_absent=0"><WhatsIcon /></a>
                </SocialIcons>

                <FooterDetails>
                    <article>
                        <span><a href="">Política de Privacidade</a></span>
                        <span><a href="">Termos de uso</a></span>
                    </article>
                    
                    <a href="https://www.lab721.com.br/"><LabIcon /></a>
                </FooterDetails>
            </FooterContent>
        </FooterContainer>
    )
}

export default Footer;